import React from "react";
import { Outlet } from "react-router-dom";
import { UseCaseManager } from "@curio/client/react";
import { useAuth } from "@context/AuthProvider";
import { useCurrentTabId } from "@context/CurrentTabContext";

const DOCUMENTS_USE_CASE_ID = "2593";

const DocumentsLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { session } = useAuth();
  const tabId = useCurrentTabId();
  const storageKey = tabId ? `ged:uc:${tabId}` : undefined;

  return (
    <UseCaseManager
      session={session}
      useCaseId={DOCUMENTS_USE_CASE_ID}
      storageKey={storageKey}
      reconnect={!!tabId}
      autoClose={false}>
      {children ?? <Outlet />}
    </UseCaseManager>
  );
};

export default DocumentsLayout;
